



import ReadMe from './ReadMe.js';

import styles from './readme.module.css';






export default ReadMe;


export {
  styles,

}
